import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid } from "recharts";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { CardContent } from "@/core/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/core/components/ui/chart";
import { useGetBusinessWeeklyStats } from "@/business/query";
import { useBusiness } from "@/core/business";
import { DashboardPaneCard } from "./dashboard-pane-card";

const chartConfig = {
  referral_count: {
    label: "Referrals",
    color: "#00BDCF",
  },
};

const ReferralsChartPane = React.memo(() => {
  const { businessId } = useBusiness();
  const { data, isLoading } = useGetBusinessWeeklyStats(businessId);

  if (isLoading) {
    return (
      <DashboardPaneCard className="flex flex-col" title="Referrals">
        <LoadingSpinner flexHeight style={{ aspectRatio: "16/9" }} />
      </DashboardPaneCard>
    );
  }

  return (
    <DashboardPaneCard title="Referrals">
      <CardContent className="p-0 pr-6">
        <ChartContainer config={chartConfig}>
          <LineChart
            accessibilityLayer
            data={data}
            margin={{
              left: 12,
              right: 12,
              top: 10,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="week_range"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              height={60}
              tickFormatter={(value) => value.split(" - ")[0]}
            />
            <YAxis
              width={40}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              allowDecimals={false}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            <Line
              dataKey="referral_count"
              type="monotone"
              stroke={chartConfig.referral_count.color}
              strokeWidth={2}
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </DashboardPaneCard>
  );
});

export default ReferralsChartPane;
